import { SVGProps, memo } from 'react';

function SvgComponent({ className = '', opacity = 0.7, ...rest }: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width='36'
      height='23'
      viewBox='0 0 40 26'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
      {...rest}
    >
      {/* Vehicle body */}
      <rect
        x='1'
        y='1'
        width='38'
        height='24'
        rx='1.5'
        stroke='currentColor'
        strokeWidth='1'
        fill='none'
      />
      {/* Left arrowhead */}
      <polygon points='3,13 10,9 10,17' fill='currentColor' opacity={opacity} />
      {/* Shaft */}
      <line x1='10' y1='13' x2='30' y2='13' stroke='currentColor' strokeWidth='1.5' opacity={opacity} />
      {/* Right arrowhead */}
      <polygon points='37,13 30,9 30,17' fill='currentColor' opacity={opacity} />
    </svg>
  );
}

const CrabSetting0 = memo(SvgComponent);
export default CrabSetting0;
